export default {
  data() {
    return {
      isFullPage: true,
      loadingComponent: null,
    };
  },
  methods: {
    OpenLoading(msg) {
      if (msg) {
        this.toastInfo(msg);
      }
      this.loadingComponent = this.$buefy.loading.open({
        container: this.isFullPage ? null : this.$refs.element.$el,
      });
    },
    CloseLoading() {
      this.loadingComponent.close();
    },
  },
};
